import React, { useEffect, useState } from "react";
import {
  Card,
  Container,
  CardBody,
  CardSubtitle,
  CardTitle,
  CardText,
  Button,
  ModalBody,
  Modal,
} from "reactstrap";
import TuneIcon from "@mui/icons-material/Tune";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReplayIcon from "@mui/icons-material/Replay";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import {
  Unstable_NumberInput as BaseNumberInput,
  numberInputClasses,
} from "@mui/base/Unstable_NumberInput";
import { styled } from "@mui/system";
import {
  fetchAllVendorList,
  fetchProductListForVendorAllocation,
  fetchFilterListForAllocation,
  saveDistributedQuantity,
} from "../../api/approval";
import { products } from "../../api/requisition";
import { toast } from "react-toastify";
import { Star } from "@mui/icons-material";
import StockRightSideBar from "./StockRightSideBar";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {getStockInHand} from '../../api/requisition';
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../store/pageHeader/action";
import assignImg from '../../assets/images/festival.svg'

const PurchaseManagerAssignVendor = () => {

  const dispatch = useDispatch();
  dispatch(StorePageHeaderName('Assign Vendor'))

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [clickOnEdit, setClickOnEdit] = useState(false);
  const [editedRows, setEditedRows] = useState([]);
  const [allocationQtyMap, setAllocationQtyMap] = useState({});
  const [gridLoad, setGridLoad] = useState(false);
  const [approvalrows, setApprovalrows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [productWiseVendorList, setProductWiseVendorList] = useState([]);
  const [newRows, setNewRows] = useState({});
  const [vendorList, setVendorList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);


  const [modifyRowMap, setModifyRowMap] = useState({});
  const [totalDistributed, setTotalDistributed] = useState(0);
  const [selectedQuantity, setSelectedQuantity] = useState(0);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [savedRows, setSavedRows] = useState([]);
  const [vendorListLoad, setVendorListLoad] = useState(false);
  const [mergedArray, setMergedArray] = useState(null);
  const [open, setOpen] = useState(false)
  const [showList, setShowList] = useState(false);  

  const handleSaveClick = (identifier) => {

    if(totalDistributed > selectedQuantity){
      toast.error("Distributed Quantity cannot be more than required quantity");
      return;
    }
    
    let id = approvalrows[selectedRow]?.id;
    let arr = [...savedRows]
    let edited = [...editedRows];
    if (identifier) {

      let [_, index] = identifier.split("+");
      arr = arr.filter(el => el.id !== identifier);

      if(!newRows[id][index].vendor_name || !newRows[id][index].vendor_code ){
        toast.error("Please fill all fields");
        return;
      }

      arr.push({
        id: identifier,
        total_qty:
          newRows[id][index].Approved_Qty == 0
            ? newRows[id][index].Quantity
            : Number(newRows[id][index].Approved_Qty),
        dp: approvalrows[selectedRow]?.Single_DP_Value,
        mop: approvalrows[selectedRow]?.Single_MOP,
        v_code: newRows[id][index]?.vendor_code,
        v_name: newRows[id][index]?.vendor_name,
        item_no: approvalrows[selectedRow]?.Product_No,
        item_name: approvalrows[selectedRow]?.Product_Name,
      });

      let obj = { ...newRows };
      let modified = { ...modifyRowMap };

      obj[id][index].Quantity =
        newRows[id][index].Approved_Qty == 0
          ? newRows[id][index].Quantity
          : Number(newRows[id][index].Approved_Qty);

      delete modified[identifier];

      edited.push(identifier);
      setNewRows(obj);
      setModifyRowMap(modified);
    } else {
      arr = arr.filter(el => el.id !== id);

      if(!approvalrows[selectedRow].vendor_name || !approvalrows[selectedRow].vendor_code ){
        toast.error("Please fill all fields");
        return;
      }

      arr.push({
        id: id,
        total_qty:
          approvalrows[selectedRow].Approved_Qty == 0
            ? approvalrows[selectedRow].Quantity
            : Number(approvalrows[selectedRow].Approved_Qty),
        dp: approvalrows[selectedRow]?.Single_DP_Value,
        mop: approvalrows[selectedRow]?.Single_MOP,
        v_code: approvalrows[selectedRow]?.vendor_code,
        v_name: approvalrows[selectedRow]?.vendor_name,
        item_no: approvalrows[selectedRow]?.Product_No,
        item_name: approvalrows[selectedRow]?.Product_Name,
      });

      let arr2 = [...approvalrows];
      let modified = { ...modifyRowMap };

      arr2[selectedRow].Quantity =
        arr2[selectedRow].Approved_Qty == 0
          ? arr2[selectedRow].Quantity
          : Number(arr2[selectedRow].Approved_Qty);

      delete modified[approvalrows[selectedRow]?.id];

      edited.push(id);
      setApprovalrows(arr2);
      setModifyRowMap(modified);
    }

    setSavedRows(arr);
    setEditedRows(edited);
  };

  const handleSaveAllClick = () => {

    if(totalDistributed > selectedQuantity){
      toast.error("Distributed Quantity cannot be more than required quantity");
      return;
    }

    let arr = [];
    let id = approvalrows[selectedRow]?.id;
    let arr2 = [...editedRows];
    arr.push({
      id: id,
      total_qty:
        approvalrows[selectedRow].Approved_Qty == 0
          ? approvalrows[selectedRow].Quantity
          : Number(approvalrows[selectedRow].Approved_Qty),
      dp: approvalrows[selectedRow]?.Single_DP_Value,
      mop: approvalrows[selectedRow]?.Single_MOP,
      v_code: approvalrows[selectedRow]?.vendor_code,
      v_name: approvalrows[selectedRow]?.vendor_name,
      item_no: approvalrows[selectedRow]?.Product_No,
      item_name: approvalrows[selectedRow]?.Product_Name,
    });
    arr2.push(id);
    if (newRows[id]) {
      let idx = 0;
      for (let { Approved_Qty, Quantity, vendor_code, vendor_name } of newRows[
        id
      ]) {
        arr.push({
          id: `${id}+${idx}`,
          total_qty: Approved_Qty == 0 ? Quantity : Number(Approved_Qty),
          dp: approvalrows[selectedRow]?.Single_DP_Value,
          mop: approvalrows[selectedRow]?.Single_MOP,
          v_code: vendor_code,
          v_name: vendor_name,
          item_no: approvalrows[selectedRow]?.Product_No,
          item_name: approvalrows[selectedRow]?.Product_Name,
        });

        arr2.push(`${approvalrows[selectedRow]?.id}+${idx}`);
        idx++;
      }
    }

    let rows = [...approvalrows];
    let obj = { ...newRows };

    for (let i = 0; i < arr.length; i++) {
      let { total_qty } = arr[i];
      let id = rows[selectedRow].id;
      if (i == 0) {
        rows[selectedRow].Approved_Qty = 0;
        rows[selectedRow].Quantity = total_qty;
      } else {
        obj[id][i - 1].Approved_Qty = 0;
        obj[id][i - 1].Quantity = total_qty;
      }
    }

    setApprovalrows(rows);
    setNewRows(obj);
    setModifyRowMap({});

    setEditedRows(arr2);
    setSavedRows(arr);
  };

  useEffect(() => {
    let totalSum = 0;

    for (let v of Object.values(allocationQtyMap)) {
      totalSum += Number(v);
    }

    setTotalDistributed(totalSum);
  }, [allocationQtyMap]);

  useEffect(() => {
    if (selectedRow !== null) {
      let totalSum = 0;

      let id = approvalrows[selectedRow].id;
      let sum =
        !editedRows.includes(id)
          ? approvalrows[selectedRow].Quantity
          : approvalrows[selectedRow].Approved_Qty;

      totalSum += Number(sum);
      if (newRows[id]) {
        let idx = 0
        for (let { Quantity, Approved_Qty } of newRows[id]) {
          if (!editedRows.includes(`${id}+${idx}`)) {
            totalSum += Number(Quantity);
          } else {
            totalSum += Number(Approved_Qty);
          }
        }
      }

      setTotalDistributed(totalSum);

      
    }
  }, [selectedRow, editedRows]);

  useEffect(() => {
    // fetchVendorListAll({
    //   search_val: approvalrows[selectedRow]?.Product_No,
    //   search_type: "item_code",
    // });
    // console.log("search_item_no:", selectedRow, approvalrows[selectedRow]?.Product_No)
    if(selectedRow != null){
      
      fetchVendorListAll({
        search_item_no: approvalrows[selectedRow]?.Product_No
      });
    }
  }, [selectedRow]);

  const saveDistributedItem = async (payload) => {
    try {

      const modifiedDistributedItems = await saveDistributedQuantity(payload);
      if (modifiedDistributedItems.statusCode !== 200) {
        toast.error("Saved item not distributed in purchase manager");
      } else {
        toast.success("Successfully distributed Products");
      }
    } catch (error) {
      console.log('Error in distributing Quantity purchase manager', error)
      toast.error("Error in distributing Quantity purchase manager");
    } finally {
      
        fetchVendorProducts();
    }
  };

  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
    setClickOnEdit(false);
    setAllocationQtyMap({});
    let arr = [...approvalrows];
    arr[selectedRow].Approved_Qty = 0;
    setApprovalrows(arr);
    setSelectedRow(null);
    setModifyRowMap({});
    setNewRows({});
    setTotalDistributed(0);
    setSavedRows([]);
  };
  const handleEditClick = (value) => {
    if (modifyRowMap[value]) {
      let obj = { ...modifyRowMap };
      delete obj[value];
      setModifyRowMap(obj);
    } else {
      let obj = { ...modifyRowMap };
      obj[value] = true;
      setModifyRowMap(obj);
    }
  };
  document.title = "Dashboard | Procurement Dashboard";
  //   const vendorList = [
  //     { label: "Zhonghan Wantai" },
  //     { label: "China Best" },
  //     { label: "Vendor 3" },
  //   ];
  const columns = [
    {
      field: "Sl_No",
      headerName: (
        <div>
          <span>SL.No</span>
        </div>
      ),
      width: 90,
      flex: 1,
      resizable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="d-flex align-items-center">
           <div><span>{params.value}</span></div>
            {params.row.status == "DISTRIBUTED" && (
              <div><Star style={{ fontSize: "17px", color:'#ED9F07',marginBottom:'4px' }} /></div>
            )}
          </div>
        );
      },
    },
    {
      field: "Product_Name",
      headerName: "Product Name",
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      width: 250,
      sortable: false,
      editable: false,
      resizable: false,
      renderCell: (params) => {
        const productName = params.value;
        return (
          <div
            onClick={() => {
              setSelectedRow(params.row.Sl_No - 1);
              setSelectedQuantity(params.row.Quantity);
              openModal();
            }}
          >
            {productName}
          </div>
        );
      },
    },
    {
      field: "Quantity",
      headerName: "Quantity",
      sortable: false,
      flex: 1,
      resizable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,
    },
    // {
    //   field: "Single_MOP",
    //   headerName: "FOB",
    //   resizable: false,
    //   sortable: false,
    //   headerAlign: 'center',
    //   cellClassName: 'center-aligndata',
    //   flex: 1,
    //   // width: 160,
    // },
    {
      field: "mop",
      headerName: "MOP",
      resizable: false,
      sortable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1,
      // width: 160,
    },

    // {
    //   field: "MOP",
    //   headerName: "Total FOB",
    //   resizable: false,
    //   sortable: false,
    //   headerAlign: 'center',
    //   cellClassName: 'center-aligndata',
    //   flex: 1,
    //   // width: 160,
    //   renderCell: (params) => {
    //     return (
    //         <div >
    //             {params.value.toFixed(2)}
    //         </div>
    //     );
    // },
    // },

    {
      field: "DP_Value",
      headerName: "DP Value",
      resizable: false,
      sortable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1,
      renderCell: (params) => {
        return (
            <div >
                {params.value.toFixed(2)}
            </div>
        );
    },
      // width: 160,
    },
    
    {
      field: "vendor_name",
      headerName: "Vendor Name",
      resizable: false,
      sortable: false,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      flex: 1,
      // width: 160,
    },
  ];
  const handleEyeIconClick =async (params) => {
    try {
      console.log('params----', params)
      const response = await getStockInHand({itemNo: params.row.Product_No})
      if(response.statusCode===200){
        setMergedArray({product_name: params.row.Product_Name, product_code: params.row.Product_No, stock_records: response.data.mergedArray
        })
        setOpen(true)

    }
    }catch(error){
        console.log('error in fetching stock in hand--', error)
        toast.error('Error in fetching stock in hand')
    }
};

  const fetchVendorProducts = async (filter = true) => {

    let formattedProducts = []

    try {
      setGridLoad(true);

      let productApprovalList, result;

      let payload = {}
      if(filter){
        if(selectedVendor){
          payload.vendor_code = selectedVendor.value
        }
  
        if(selectedProduct){
          payload.item_no = selectedProduct.value
        }
  
        if(selectedCategory){
          payload.category = selectedCategory.value
        }
      }
     
      

      productApprovalList = await fetchProductListForVendorAllocation(payload);

      result = productApprovalList.data.distributedProductList;


      if (productApprovalList.statusCode === 200 && result.length > 0) {

         formattedProducts = result.map((product, index) => ({

          id: product.id, // Assuming index + 1 as ID
          Sl_No: index + 1, // Serial Number
          Product_Name: product.item_name,
          Product_No: product.item_no,
          Quantity: product.total_qty,
          Approved_Qty: 0,
          DP_Value: product.dp * product.total_qty,
          Single_DP_Value: product.dp,
          MOP: product.mop * product.total_qty,
          Single_MOP: product.mop,
          vendor_name: product.v_name,
          vendor_code: product.v_code,
          status: product.status,
          requisition_number:
            product.procurementRequisitionItem.procurementRequisition
              .requisition_number,
          requisition_date:
            product.procurementRequisitionItem.procurementRequisition
              .requisition_date,
        }));

      }
    } catch (error) {
      toast.error("Error in fetching approval list for purchase");
      console.log(error);
    } finally {
      setApprovalrows(formattedProducts)

      setGridLoad(false);
    }
  };

  const fetchFilterList = async () => {
    try {

      if(!vendorListLoad){
        setVendorListLoad(true);
        const list = await fetchFilterListForAllocation({filter_type:['product', 'category','vendor']});
        
        setProductList(
          list.data.response.productList
        );
        setCategoryList(
          list.data.response.categoryList
        );
        setVendorList(
          list.data.response.vendorList
        );
      }
    } catch (error) {
      toast.error("Error in fetching vendor list for assign vendor");
      console.log(error);
    } finally {
      setVendorListLoad(false);
    }
  };

  // const fetchVendorListAll = async (data) => {
  //   try {
  //     setGridLoad(true);
  //     const vendorList = await fetchAllVendorList(data);
  //     setProductWiseVendorList(
  //       vendorList.data.filteredVendorList.map((el) => {
  //         return { label: el.Vname, value: el.Vcode };
  //       })
  //     );
  //   } catch (error) {
  //     toast.error("Error in fetching vendor list for assign vendor");
  //     console.log(error);
  //   } finally {
  //     setGridLoad(false);
  //   }
  // };
  const fetchVendorListAll = async (data) => {
    try {
      setGridLoad(true);
      // const vendorList = await fetchAllVendorList(data);
      const vendorList = await products(data);

      setProductWiseVendorList(
        vendorList.data.productList[0].flatMap((el) => {
          const Vnames = el.Vname.trim().split(',');
          const Vcodes = el.Vcode.trim().split(',');
          const minLength = Math.min(Vnames.length, Vcodes.length);
          return Vnames.slice(0, minLength).map((name, index) => ({
            label: name.trim(),
            value: Vcodes[index].trim()
          }));
        })
      );
    } catch (error) {
      toast.error("Error in fetching vendor list for assign vendor");
      console.log(error);
    } finally {
      setGridLoad(false);
    }
  };

  useEffect(() => {

    fetchFilterList();
  }, []);

  useEffect(() => {
    fetchVendorProducts();
  }, [
    // selectedVendor, selectedProduct, selectedCategory
  ]);

  const handleVendorSelect = (e, myvalue) => {
    setSelectedVendor(myvalue || null);
  };

  const handleProductSelect = (e, myvalue) => {
    setSelectedProduct(myvalue || null);
  };

  const handleCategorySelect = (e, myvalue) => {
    setSelectedCategory(myvalue || null);
  };

  const handleAddNewRow = async () => {
    let obj = { ...newRows };
    let newValue = {
      Quantity: selectedQuantity - totalDistributed  ,
      Approved_Qty: 0,
      vendor_name: "",
      vendor_code: "",
    };
    obj[approvalrows[selectedRow].id]
      ? obj[approvalrows[selectedRow].id].push(newValue)
      : (obj[approvalrows[selectedRow].id] = [newValue]);
    setNewRows(obj);
  };

  const blue = {
    100: "#DAECFF",
    200: "#80BFFF",
    400: "#3399FF",
    500: "#007FFF",
    600: "#0072E5",
    700: "#0059B2",
  };

  const grey = {
    50: "#F3F6F9",
    100: "#E5EAF2",
    200: "#DAE2ED",
    300: "#C7D0DD",
    400: "#B0B8C4",
    500: "#9DA8B7",
    600: "#6B7A90",
    700: "#434D5B",
    800: "#303740",
    900: "#1C2025",
  };

  const StyledInputRoot = styled("div")(
    ({ theme }) => `
            font-family: 'IBM Plex Sans', sans-serif;
            font-weight: 400;
            border-radius: 4px;
            color: #0060AA;
            background: transparent;
            border: 1px solid #0060AA;
            box-shadow: 0px 2px 4px ${
              theme.palette.mode === "dark"
                ? "rgba(0,0,0, 0.5)"
                : "rgba(0,0,0, 0.05)"
            };
            display: grid;
            grid-template-columns: 1fr 19px;
            grid-template-rows: 1fr 1fr;
            overflow: hidden;
            column-gap: 8px;
            padding: 3px 4px;
          
            &.${numberInputClasses.focused} {
              border-color: #0060AA;
            }
          
            &:hover {
              border-color: #0060AA;
            }
          
            // firefox
            &:focus-visible {
              outline: 0;
            }
          `
  );

  const StyledInputElement = styled("input")(
    ({ theme }) => `
            font-size: 1rem;
            font-family: inherit;
            font-weight: 400;
            line-height: 1.5;
            grid-column: 1/2;
            grid-row: 1/3;
            color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
            background: inherit;
            border: none;
            border-radius: inherit;
            padding: 2px 12px;
            outline: 0;
          `
  );

  const StyledButton = styled("button")(
    ({ theme }) => `
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            appearance: none;
            padding: 0;
            width: 0px;
            height: 19px;
            font-family: system-ui, sans-serif;
            font-size: 0.875rem;
            line-height: 1;
            box-sizing: border-box;
            background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
            border: 0;
            color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 120ms;
          
            &:hover {
              background: ${
                theme.palette.mode === "dark" ? grey[800] : grey[50]
              };
              border-color: ${
                theme.palette.mode === "dark" ? grey[600] : grey[300]
              };
              cursor: pointer;
            }
          
            &.${numberInputClasses.incrementButton} {
              grid-column: 2/3;
              grid-row: 1/2;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              border: 1px solid;
              border-bottom: 0;
              border-color: transparent;
              background: transparent;
              color: #0060AA;
          
              &:hover {
                cursor: pointer;
                color: #0060AA;
                background: transparent;
                border-color:transparent;
              }
            }
          
            &.${numberInputClasses.decrementButton} {
              grid-column: 2/3;
              grid-row: 2/3;
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
              border: 1px solid;
              border-color:transparent;
              background: transparent;
              color: #0060AA;
            }
          
            &:hover {
              cursor: pointer;
              color: #0060AA;
              background: transparent;
              border-color: transparent;
            }
          
            & .arrow {
              transform: translateY(-1px);
            }
          
            & .arrow {
              transform: translateY(-1px);
            }
          `
  );
  const CustomNumberInput = React.forwardRef(function CustomNumberInput(
    props,
    ref
  ) {
    return (
      <BaseNumberInput
        slots={{
          root: StyledInputRoot,
          input: StyledInputElement,
          incrementButton: StyledButton,
          decrementButton: StyledButton,
        }}
        slotProps={{
          incrementButton: {
            children: "▴",
          },
          decrementButton: {
            children: "▾",
          },
        }}
        {...props}
        ref={ref}
      />
    );
  });

  const handlePrevRowAutocompleteChange = (event, newValue) => {
    let rows = [...approvalrows];
    rows[selectedRow].vendor_name = newValue.label;
    rows[selectedRow].vendor_code = newValue.value;
    setApprovalrows(rows);
  };

  const handleNewRowAutocompleteChange = (data, newValue) => {
    let [id, index] = data.split("+");

    let obj = { ...newRows };
    obj[approvalrows[id].id][index].vendor_name = newValue.label;
    obj[approvalrows[id].id][index].vendor_code = newValue.value;
    setNewRows(obj);
  };

  const handleDone = () => {

    if(totalDistributed > selectedQuantity){
      toast.error("Distributed Quantity cannot be more than required quantity");
      return;
    }

    let data = {
      division_id: approvalrows[selectedRow]?.id,
      records: savedRows.map(el => {
        delete el['id'];
        return el;
      }),
    };

    saveDistributedItem(data);

    closeModal();
  };

  const toggleList = () => {
    setShowList(!showList);
  };

  const handleReset = () => {
    fetchVendorProducts(false);
    setSelectedVendor(null);
    setSelectedProduct(null);
    setSelectedCategory(null);


  }

  const handleStockClick = (isOpen) => {
    setOpen(isOpen)      
  };

  return (
    <React.Fragment>
         {
            open &&(
                <StockRightSideBar handleStockClick={handleStockClick}   mergedArray={mergedArray}
                />
            )
            }
      <div className="page-content">
        <Container fluid>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: 'space-between',
                alignItems: "center",
                // marginTop: "10px",
              }}
            >
              <div>
                <h4 className="mb-0 requisition_text">Assignee Vendor</h4>
              </div>
              <div className="d-flex align-items-center gap-2">
                {/* <div>
                  <button onClick={toggleList} variant="outlined" className="filter_button"><span className="me-2"><TuneIcon /></span>Filter</button>
                </div> */}
                 <div>
                  <Autocomplete
                    className="data_field"
                    disablePortal
                    id="combo-box-demo"
                    options={vendorList}
                    value={selectedVendor}
                    sx={{ width: 230 }}
                    // onInputChange={(event, newValue) => handleVendorSelect(event, vendorList.find(el => el.label == newValue))}
                    //       onChange={(event, newValue) => handleVendorSelect(event, newValue)}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Vendor" />
                    )}
                  />
                </div>
                <div>
                  <button className="save_button">
                    <span className="me-2 mb-1">
                      <img src={assignImg} />
                      </span>
                      <span>Assign Vendor</span>
                  </button>
                </div>
              </div>
            </div>
            {showList && (
              <div className="d-flex align-items-center gap-2">
                <div>
                  <Autocomplete
                    className="data_field"
                    disablePortal
                    id="combo-box-demo"
                    options={vendorList}
                    value={selectedVendor}
                    sx={{ width: 230 }}
                    onInputChange={(event, newValue) => handleVendorSelect(event, vendorList.find(el => el.label == newValue))}
                          onChange={(event, newValue) => handleVendorSelect(event, newValue)}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Vendor" />
                    )}
                  />
                </div>
                <div>
                                    <Autocomplete
                                        className="data_field"
                                        disablePortal
                                        id="combo-box-demo"
                                        options={productList}
                                        value={selectedProduct}
                                        sx={{ width: 230 }}

                                        onInputChange={(event, newValue) => handleProductSelect(event, productList.find(el => el.label == newValue), 'product')}
                                        onChange={(event, newValue) => handleProductSelect(event, newValue, 'product')}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Product" />
                                        )}
                                    />
                                </div>
                                <div>
                                    <Autocomplete
                                        className="data_field"
                                        disablePortal
                                        id="combo-box-demo"
                                        options={categoryList}
                                        sx={{ width: 230 }}
                                        value={selectedCategory}
                                        onInputChange={(event, newValue) => handleCategorySelect(event, categoryList.find(el => el.label == newValue), 'category')}
                                        onChange={(event, newValue) => handleCategorySelect(event, newValue, 'category')}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Select Category" />
                                        )}
                                    />
                                </div>
                                <div className="d-flex align-items-center">
                                   <button className="me-2 search_button" variant="outlined" onClick={fetchVendorProducts}>Search</button>
                                   <ReplayIcon onClick={handleReset} />
                               </div>
              
              </div>
            )}
            <Box
              sx={{
                height: "100%",
                width: "100%",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              <DataGrid
                autoHeight
                className="table_header_background"
                headerClassName="custom-header-cell"
                rows={approvalrows}
                columns={columns}
                loading={gridLoad}
                disableRowSelectionOnClick
                disableColumnMenu
                disableColumnResize={true}
                componentsProps={{
                    cell: {
                        disableClick: true,
                    },
                }}
                sx={{
                    '& .MuiDataGrid-cell': {
                        '& .MuiDataGrid-cell--textOverflow': {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        },
                    },
                }}
              />
            </Box>
          </div>
          {/* <Card>
                        <CardBody className="ps-0 pe-0 pt-0">
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th className="text-center">Item Count</th>
                                            <th className="text-center">Total Quantity</th>
                                            <th className="text-center">Total FOB</th>
                                            <th className="text-center">Total DP Value</th>

                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td className="text-center">{approvalrows.length}</td>
                                                <td className="text-center">{approvalrows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Quantity;
                                                }, 0)}</td>
                                                <td className="text-center">{approvalrows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.MOP;
                                                }, 0).toFixed(2)}</td>
                                                <td className="text-center">{approvalrows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.DP_Value;
                                                }, 0).toFixed(2)}</td>
                                                
                                                
                                            </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
          </Card> */}
        </Container>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        className="modal-dialog purchase_approval_requisiton_modal modal_box"
      >
        <div className="d-flex justify-content-between me-2 mt-3">
          <h4 className="ms-3">
            Choose Vendor for {approvalrows[selectedRow]?.Product_Name}
          </h4>
          <div className="d-flex justify-content-end me-3 modal_close">
            <i class="ri-close-line" onClick={closeModal}></i>
          </div>
        </div>
        <hr className="mb-2 mt-1 ms-3 me-3"></hr>
        <ModalBody className="pt-2">
          <div className="d-flex align-items-center" style={{ gap: "12px" }}>
            <div>
              <h6 className="requisition_type_text">Requisition Number</h6>
              <p className="mb-0">
                {approvalrows[selectedRow]?.requisition_number}
              </p>
              {/* <TextField
                      className="addrequisiton_field"
                      id={`reqNo-${index}`}
                      label="Requisition Number"
                      variant="outlined"
                      value={row.requisition_no}
                      onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                      sx={{ width: 160 }}
                      disabled={true}

                  /> */}
            </div>
            <div>
              <h6 className="requisition_type_text">Requisition Date</h6>
              <p className="mb-0">
                {approvalrows[selectedRow]?.requisition_date}
              </p>
              {/* <TextField
                      className="addrequisiton_field"
                      id={`reqDate-${index}`}
                      label="Requisition Date"
                      variant="outlined"
                      value={row.requisition_date}
                      onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                      sx={{ width: 160 }}
                      disabled={true}

                  /> */}
            </div>

            <div>
              <Autocomplete
                className="vendorList_field"
                disablePortal
                id={selectedRow}
                options={productWiseVendorList}
                sx={{ width: 200 }}
                value={{
                  label: approvalrows[selectedRow]?.vendor_name || "",
                  value: approvalrows[selectedRow]?.vendor_code || "",
                }}
                onChange={handlePrevRowAutocompleteChange}
                renderInput={(params) => (
                  <TextField {...params} label="Select Vendor" />
                )}
                disabled={!modifyRowMap[approvalrows[selectedRow]?.id]}
              />
            </div>
            <div>
              <CustomNumberInput
                sx={{ width: "100px" }}
                aria-label="Demo number input"
                placeholder="Quantity"
                value={approvalrows[selectedRow]?.Quantity}
                disabled
              />
            </div>
            <div>
              <>
                {modifyRowMap[approvalrows[selectedRow]?.id] && (
                  <TextField
                    type="number"
                    className="addrequisiton_field"
                    // id={`allocated-quantity-${index}`}
                    label="Distributed Quantity"
                    variant="outlined"
                    value={approvalrows[selectedRow]?.Approved_Qty || ""}
                    onChange={(event) => {
                      let newRows = [...approvalrows];
                      newRows[selectedRow].Approved_Qty = event.target.value;

                      let qtyObj = { ...allocationQtyMap };
                      qtyObj[approvalrows[selectedRow]?.id] =
                        event.target.value;
                      setAllocationQtyMap(qtyObj);
                      setApprovalrows(newRows);
                    }}
                    sx={{ width: "140px" }}
                  />
                )}
                {/* {editedRows.includes(index)  && (
                                                <div style={{ color: 'red', marginTop: '4px' }}>
                                                    {rowErrors[index]}
                                                </div>
                                            )} */}
              </>
              {!modifyRowMap[approvalrows[selectedRow]?.id] && (
                <button
                  className="approval_edit ms-0"
                  onClick={() =>
                    handleEditClick(approvalrows[selectedRow]["id"])
                  }
                >
                  Edit
                </button>
              )}
              {modifyRowMap[approvalrows[selectedRow]?.id] && (
                <button
                  className="approval_edit ms-2"
                  onClick={() => handleSaveClick()}
                >
                  Modify
                </button>
              )}
            </div>
            {!modifyRowMap[approvalrows[selectedRow]?.id] &&
              !editedRows.includes(approvalrows[selectedRow]?.id) && (
                <div>
                  <button
                    className="approval_edit"
                    onClick={() => handleSaveClick()}
                  >
                    Save
                  </button>
                </div>
              )}
          </div>
          <hr className="mb-2 mt-2"></hr>

          {newRows[approvalrows[selectedRow]?.id]?.map((el, idx) => (
            <div key={idx}>
              <div
                className="d-flex align-items-center"
                style={{ gap: "12px" }}
              >
                <div>
                  <h6 className="requisition_type_text">Requisition Number</h6>
                  <p className="mb-0">
                    {approvalrows[selectedRow]?.requisition_number}
                  </p>
                  {/* <TextField
                          className="addrequisiton_field"
                          id={`reqNo-${index}`}
                          label="Requisition Number"
                          variant="outlined"
                          value={row.requisition_no}
                          onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                          sx={{ width: 160 }}
                          disabled={true}

                      /> */}
                </div>
                <div>
                  <h6 className="requisition_type_text">Requisition Date</h6>
                  <p className="mb-0">
                    {approvalrows[selectedRow]?.requisition_date}
                  </p>
                  {/* <TextField
                          className="addrequisiton_field"
                          id={`reqDate-${index}`}
                          label="Requisition Date"
                          variant="outlined"
                          value={row.requisition_date}
                          onChange={(event) => handleInputChange(index, 'value', event.target.value)}
                          sx={{ width: 160 }}
                          disabled={true}

                      /> */}
                </div>

                <div>
                  <Autocomplete
                    className="vendorList_field"
                    disablePortal
                    id={"newAutocomplete"}
                    data-id={`${selectedRow}+${idx}`}
                    options={productWiseVendorList}
                    sx={{ width: 200 }}
                    onChange={(event, value) =>
                      handleNewRowAutocompleteChange(
                        `${selectedRow}+${idx}`,
                        value
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={el?.vendor_name}
                        label="Select Vendor"
                      />
                    )}
                  />
                </div>
                <div>
                  <CustomNumberInput
                    sx={{ width: "120px" }}
                    aria-label="Demo number input"
                    placeholder="Quantity"
                    value={el?.Quantity}
                    disabled
                  />
                </div>
                <div>
                  <>
                    {modifyRowMap[
                      `${approvalrows[selectedRow]?.id}+${idx}`
                    ] && (
                      <TextField
                        type="number"
                        className="addrequisiton_field"
                        // id={`allocated-quantity-${index}`}
                        label="Distributed Quantity"
                        variant="outlined"
                        value={el?.Approved_Qty}
                        max={el?.Quantity}
                        onChange={(event) => {
                          let obj = { ...newRows };

                          obj[approvalrows[selectedRow].id][idx].Approved_Qty =
                            event.target.value;
                          let qtyObj = { ...allocationQtyMap };
                          qtyObj[`${approvalrows[selectedRow]?.id}+${idx}`] =
                            event.target.value;
                          setAllocationQtyMap(qtyObj);
                          setNewRows(obj);
                        }}
                        sx={{ width: "140px" }}
                      />
                    )}
                    {/* {editedRows.includes(index) && (
                        <div style={{ color: 'red', marginTop: '4px' }}>
                        {rowErrors[index]}
                        </div>
                        )} */}
                  </>
                  {!modifyRowMap[`${approvalrows[selectedRow]?.id}+${idx}`] && (
                    <button
                      className="approval_edit"
                      onClick={() =>
                        handleEditClick(
                          `${approvalrows[selectedRow]?.id}+${idx}`
                        )
                      }
                    >
                      Edit
                    </button>
                  )}

                  {modifyRowMap[`${approvalrows[selectedRow]?.id}+${idx}`] && (
                    <button
                      className="approval_edit ms-2"
                      onClick={() =>
                        handleSaveClick(
                          `${approvalrows[selectedRow]?.id}+${idx}`
                        )
                      }
                    >
                      Modify
                    </button>
                  )}
                </div>
                {!modifyRowMap[`${approvalrows[selectedRow]?.id}+${idx}`] &&
                  !editedRows.includes(
                    `${approvalrows[selectedRow]?.id}+${idx}`
                  ) && (
                    <div>
                      <button
                        className="approval_edit"
                        onClick={() =>
                          handleSaveClick(
                            `${approvalrows[selectedRow]?.id}+${idx}`
                          )
                        }
                      >
                        Save
                      </button>
                    </div>
                  )}
              </div>
              <hr className="mb-2 mt-2"></hr>
            </div>
          ))}

          <div className="mt-3">
            <button
              className="add_more_button"
              onClick={handleAddNewRow}
              disabled={totalDistributed >= selectedQuantity}
            >
              + Add More Vendor
            </button>
            <button
              className="add_more_button ms-2"
              onClick={handleSaveAllClick}
              disabled={totalDistributed > approvalrows[selectedRow]?.Quantity}
            >
              Save All
            </button>
          </div>
          <div className="d-flex align-items-center mt-4 justify-content-center">
            <button
              className="yes_button d-flex align-items-center"
              disabled={savedRows.length < 1}
              onClick={handleDone}
            >
              Done
            </button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default PurchaseManagerAssignVendor;
